module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/turntable-d5281f3665959418e9bed62c62e4524c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/turntable.svg
// module id = SnZ/
// module chunks = 24